import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../src/lib/component-base';

@componentBase('RadioButton')
export default class RadioButton extends Component {
  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    option: PropTypes.string,
    style: PropTypes.object,
  };

  render() {
    return (
      <div className='RadioButton' style={this.props.style}>
        <label htmlFor={this.props.name || this.props.title}>
          <input
            type='radio'
            disabled={this.props.disabled}
            name={this.props.name || this.props.title}
            checked={this.props.checked}
            onChange={this.props.onChange.bind(this, this.props.option)}
          />
          <span className={`${this.props.disabled ? 'disabled' : ''}`}>{this.props.title}</span>
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/RadioButton/RadioButton.js